import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 10.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 18H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
  </>
);

const Weather26Colored = Icon('weather-26-colored', svgContents);

export default Weather26Colored;
